import React from 'react';
import { bool, func, string } from 'prop-types';
import cn from 'classnames';

import { ReactComponent as XIcon } from '~assets/x.svg';

import styles from './styles.module.scss';

function CrossButton({ onClick, containerClassName, className, disabled, id, defaultContainerStyle }) {
  return (
    <div className={cn(containerClassName, { [styles.xIconContainer]: defaultContainerStyle })}>
      <div id={id} className={cn(styles.xIcon, className, { [styles.disabled]: disabled })} onClick={onClick}>
        <XIcon id={id} />
      </div>
    </div>
  );
}

CrossButton.defaultProps = {
  defaultContainerStyle: true
};

CrossButton.propTypes = {
  className: string,
  containerClassName: string,
  defaultContainerStyle: bool,
  disabled: bool,
  id: string,
  onClick: func
};

export default CrossButton;
